export const RECAPTCHA_ERROR = 'recaptcha_error';

export const PASSWORD_TOO_SHORT = 'password_too_short';

export const PASSWORD_ERRORS = {
  PASSWORD_TOO_SHORT,
};
